export const ADMIN_STATS_FEATURE_KEY = 'adminStatistics';
